import PremiumCoachSide from './PremiumCoachSide';

export default PremiumCoachSide;
